export const FRIEND_STATUSES = [
  "Pending",
  "Accepted",
  "Denied by you",
  "Denied by friend"
]

export enum FRIEND_STATUS {
  PENDING,
  ACCEPTED,
  DENIED_BY_YOU,
  DENIED_BY_FRIEND
}

export interface FriendInterface {
  id: number
  friendId: number
  // friendId: number
  friendStatus: FRIEND_STATUS
  firstName: string
  lastName: string
  createdAt: string
  picture: string
}

export interface ChosenPerson {
  friendId: number
  firstName: string
  picture: string
}
